import type { ValuationAgentPermission } from '@immo/api-contract';

/** The i18n key segment under `pages.admin.valuation-agent.permission`: the literal's part after `agent-`. */
export function valuationAgentPermissionLabelKey(permission: ValuationAgentPermission): string {
  return permission.slice(permission.indexOf(':agent-') + ':agent-'.length);
}
